exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageLoader[data-v-0c2ce243]{position:fixed;top:0;left:0;right:0;bottom:0;background-color:#000;z-index:100}.pageLoader__body[data-v-0c2ce243]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/diegopaladino/Development/snoozy-strollers/node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c2ce243","scoped":true,"hasInlineConfig":true}!/Users/diegopaladino/Development/snoozy-strollers/node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../default-js/js/components/App.vue
// module id = Usks
// module chunks = 17